const teamData = [
  {
    id: 1,
    name: "Redwan Newaz, Ph.D. (PI)",
    position: "Assistant Professor, Director of the AiR Lab",
    department: "Computer Science",
    email: "aredwann@lsuneworleans.edu",
    description:
      "My research interests lie in the areas of Robotics, Artificial Intelligence, Machine Learning, Deep Learning, and Cyber-Physical Systems. Particularly, my research interests include autonomous systems, applied machine learning, motion planning under uncertainty, optimal control, deep learning-based perception methods, model checking, and related domains. My research goal is to balance both theory and practical implementations, with an emphasis on developing elegant, scalable, theoretically sound algorithms for solving real-world robotics applications.",
    photo: "redwan.jpg",
  },
  {
    id: 2,
    name: "Sourav Raxit",
    position: "Graduate Researcher (Ph.D.)",
    department: "Computer Science",
    email: "sraxit@my.lsuneworleans.edu",
    description:
      "My research focuses on the intersection of Robotics, Machine Learning, Deep Learning, and Cyber-Physical Systems. I work on sample-efficient motion planning through Bayesian optimization (BOW, BOWConnect, STLcBOT), energy-efficient multi-robot coverage path planning, and uncertainty-aware robotic information gathering, alongside vision-based localization for UAV navigation using fiducial markers.",
    photo: "sourav.png",
  },
  {
    id: 3,
    name: "Simant Bahadur Singh",
    position: "Graduate Researcher (M.S.)",
    department: "Computer Science",
    email: "sbsingh3@my.lsuneworleans.edu",
    description:
      "Advancing drone navigation through innovative trajectory planning, generation, and path-following algorithms. Enhancing UAV state estimation and localization techniques, including filtering and sensor fusion. Investigating fiducial marker systems for optimized UAV positioning in diverse environments.",
    photo: "simant.png",
  },
  {
    id: 4,
    name: "MD Muhtasim Daiyan Rahman",
    position: "Undergraduate Researcher (B.S.)",
    department: "Computer Science",
    email: "mrahma12@my.lsuneworleans.edu",
    description:
      "Undergraduate researcher in the AiR Lab working on autonomous robotic systems, supporting the lab's field robotics and intelligent decision-making projects.",
    photo: "",
  },
];

export default teamData;
